import { CreateHealthInsuranceByPatient } from 'domain/usecases/patient/create-health-insurance-by-patient'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteCreateHealthInsuranceByPatient
  implements CreateHealthInsuranceByPatient
{
  private readonly patientNewRepository: PatientNewRepository

  constructor(patientNewRepository: PatientNewRepository) {
    this.patientNewRepository = patientNewRepository
  }

  create(
    params: CreateHealthInsuranceByPatient.Params
  ): Promise<CreateHealthInsuranceByPatient.Model> {
    return this.patientNewRepository.createHealthInsuranceByPatient(params)
  }
}
